import cn from "classnames";
import { useWeekControl } from "./useWeekControl";
import styles from "./Week.module.scss";
import { IWeekProps } from "./Week.props";

interface WeekDayProps {
  isAlreadySelected: boolean;
  isSelected: boolean;
  day: string;
  dayIndex: number;
  onClick: (dayIndex: string, multiple: boolean) => void;
}

function WeekDay({
  day,
  dayIndex,
  isSelected,
  isAlreadySelected,
  onClick,
}: WeekDayProps): JSX.Element {
  return (
    <span
      className={cn({
        [styles.active]: isAlreadySelected || isSelected,
        [styles.selected]: isSelected,
      })}
      onClick={(e) => onClick(`${dayIndex}`, (e.shiftKey || e.ctrlKey))}
    >
      {day}
    </span>
  );
}

export default function Week(props: IWeekProps) {
  const control = useWeekControl(props);

  return (
    <div
      className={cn(styles.plan_week, {
        [styles.disabled]: control.disabled,
      })}
    >
      <div className={cn(styles.switcher_wrapper)}>
        <div className={styles.week_days}>
          {[1, 2, 3, 4, 5, 6, 0].map(idx =>
            <WeekDay
              key={idx}
              day={control.weekDays[idx]}
              dayIndex={idx}
              isAlreadySelected={control.isAlreadySelected(idx)}
              isSelected={control.isSelected(idx)}
              onClick={control.onSelectWeekDay}
            />
          )}
        </div>
      </div>
      <input id='week_days' hidden />
    </div>
  );
}
